<template lang="pug">
  div.overlay(
    v-show="showing"
  )
    preloader(
    )
    div(v-if="type === 'cube'").sk-folding-cube
      div.sk-cube.sk-cube-1
      div.sk-cube.sk-cube-2
      div.sk-cube.sk-cube-4
      div.sk-cube.sk-cube-3
    div(v-if="type === 'circle'").sk-fading-circle
      div.sk-circle1.sk-circle
      div.sk-circle2.sk-circle
      div.sk-circle3.sk-circle
      div.sk-circle4.sk-circle
      div.sk-circle5.sk-circle
      div.sk-circle6.sk-circle
      div.sk-circle7.sk-circle
      div.sk-circle8.sk-circle
      div.sk-circle9.sk-circle
      div.sk-circle10.sk-circle
      div.sk-circle11.sk-circle
      div.sk-circle12.sk-circle
</template>

<script>
  import PreloaderMixin from './preloader-mixin'
  export default {
    props: {
      type: {
        default: 'circle'
      },
      show: {
        default: false
      }
    },
    mixins: [PreloaderMixin],
    name: "page-preloader"
  }
</script>

<style scoped>

</style>